import styled from 'styled-components'
import Pointer from 'assets/images/Pointer.svg'
import { Popover } from 'utils/base'
import { formBreakpoint } from 'globalStyles'

interface Props {
  pointer?: boolean
}

export const DecorationContainer = styled.div<Props>`
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: ${(props) => (props.pointer ? `url(${Pointer}), pointer` : 'text')};

  & > *:not(:last-child) {
    margin-right: .8rem;
  }

  & > span {
    display: block;
    height: 100%;
    padding: 0 0.5rem;
    cursor: url(${Pointer}), pointer;
  }
`

export const Container = styled.div`
  position: relative;
  cursor: text;
`

export const OptionsPopover = styled(Popover)`
  right: 70%;
  left: auto;

  @media (max-width: ${formBreakpoint}) {
    right: auto;
  }
`

export const DatePopover = styled(Popover)`
`
